const compactFormat = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
})

export const formatCompactCredits = (amount: number): string => compactFormat.format(amount)
